// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"240":"b576ab56","243":"df4bb449","456":"82cabe06","688":"4d6c9ab4","741":"6b75a78b","995":"1c683a39"}[chunkId] + ".chunk.css";
};